<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex xs12 md6 offset-sm3>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoCrud
            :titulo="titulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <SelectPuntoVenta
                    :model="itemActivo.Id_PuntoVenta"
                    :rules="[rules.requerido]"
                    :readonly="controlSoloLectura"
                    @seleccionarItem="seleccionarPuntoVenta"
                  />
                </v-flex>
                <v-flex xs12 md2 offset-md2>
                  <v-text-field
                    label="Prefijo*"
                    v-model="itemActivo.PrefijoPuntoVenta"
                    :rules="[rules.requerido]"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <v-text-field
                    label="Nombre*"
                    v-model="itemActivo.Nombre"
                    :rules="[rules.requerido, rules.maximo50]"
                    :readonly="controlSoloLectura"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md2 offset-md2>
                  <v-text-field
                    label="Letra"
                    v-model="itemActivo.Letra"
                    v-mask="'A'"
                    :readonly="controlSoloLectura"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6 md4>
                  <v-text-field
                    label="Nº Inicial*"
                    v-model="itemActivo.NumeroDesde"
                    v-mask="'########'"
                    :rules="[rules.requerido]"
                    :readonly="controlSoloLectura"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md4>
                  <v-text-field
                    label="Nº Actual*"
                    v-model="itemActivo.NumeroActual"
                    v-mask="'########'"
                    :rules="[rules.requerido]"
                    :readonly="controlSoloLectura"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 md4>
                  <v-text-field
                    label="Nº Final*"
                    v-model="itemActivo.NumeroHasta"
                    v-mask="'########'"
                    :rules="[rules.requerido]"
                    :readonly="controlSoloLectura"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6 md4>
                  <v-text-field
                    label="Copias*"
                    v-model="itemActivo.Copia"
                    v-mask="'#'"
                    :rules="[rules.requerido]"
                    :readonly="controlSoloLectura"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4 offset-md4>
                  <Fecha
                    label="Vencimiento"
                    :fecha="itemActivo.FechaVencimiento"
                    :readonly="controlSoloLectura"
                    @seleccionarItem="
                      item => (itemActivo.FechaVencimiento = item.Fecha)
                    "
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <GrillaCrud
      :activo="grillaActivo"
      :columnas="grillaColumnas"
      :itemsDB="grillaItems"
      :loading="loading"
      @ejecutarAccion="grillaEjecutarAccion"
      @editarItem="grillaEditarItem"
      @borrarItem="grillaBorrarItem"
    />
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
import EncabezadoCrud from "@/components/EncabezadoCrud";
import PieCrud from "@/components/PieCrud";
import GrillaCrud from "@/components/GrillaCrud";
import Mensaje from "@/components/Mensaje";
import Fecha from "@/components/Fecha";
import SelectPuntoVenta from "@/components/Sistema/SelectPuntoVenta";
export default {
  name: "TalonarioCrud",
  components: {
    EncabezadoCrud,
    PieCrud,
    GrillaCrud,
    Mensaje,
    Fecha,
    SelectPuntoVenta
  },
  data() {
    return {
      titulo: "Talonarios",
      rutaApi: "Talonario/",
      itemVacio: {
        Id_Talonario: 0,
        Nombre: "",
        Id_PuntoVenta: 0,
        PrefijoPuntoVenta: 0,
        Letra: "",
        NumeroDesde: 0,
        NumeroHasta: 0,
        NumeroActual: 0,
        Copia: 0,
        FechaVencimiento: ""
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido",
        maximo50: v => (v || "").length <= 50 || "Máximo 50 caracteres"
      },
      grillaColumnas: [
        { text: "Punto de Venta", value: "NombrePuntoVenta" },
        { text: "Prefijo", value: "PrefijoPuntoVenta" },
        { text: "Nombre", value: "Nombre" },
        { text: "Letra", value: "Letra" },
        { text: "Número", value: "NumeroActual" },
        { text: "Vencimiento", value: "FechaVencimiento" }
      ],
      grillaItems: [],
      grillaActivo: false,
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      controlSoloLectura: true,
      accion: ""
    };
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Nuevo":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.controlSoloLectura = false;
          eventBus.$emit("setearFocoSelectPuntoVenta");
          break;
        case "Guardar":
          if (this.$refs.form.validate())
            this.mostrarMensaje(true, "ConfirmacionGuardar", null, null);
          break;
        case "AceptarConfirmacionGuardar":
          this.guardarItem(this.itemActivo);
          break;
        case "Abrir":
          this.grillaActivo = true;
          this.grillaItems = [];
          break;
        case "Editar":
          this.grillaActivo = false;
          this.controlSoloLectura = false;
          eventBus.$emit("setearFocoSelectPuntoVenta");
          break;
        case "Borrar":
          this.grillaActivo = false;
          this.mostrarMensaje(true, "ConfirmacionBorrar", null, null);
          break;
        case "AceptarConfirmacionBorrar":
          this.borrarItem(this.itemActivo);
          break;
        case "CancelarConfirmacionGuardar":
          this.mostrarMensaje(false);
          break;
        case "CancelarConfirmacionBorrar":
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.controlSoloLectura = true;
          this.$refs.form.resetValidation();
          break;
      }
    },
    seleccionarPuntoVenta(item) {
      this.itemActivo.Id_PuntoVenta = item.Id_PuntoVenta;
      this.itemActivo.PrefijoPuntoVenta = item.Prefijo;
    },
    guardarItem(item) {
      this.loading = true;
      HttpHelper.post(this.rutaApi, item)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    borrarItem(item) {
      this.loading = true;
      HttpHelper.delete(this.rutaApi + item.Id_Talonario)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEjecutarAccion(accion, textoBuscado) {
      switch (accion) {
        case "Listar":
          this.grillaListarItems(textoBuscado);
          break;
        case "Cerrar":
          this.grillaActivo = false;
          break;
      }
    },
    grillaListarItems(textoBuscado) {
      this.loading = true;
      this.grillaItems = [];
      HttpHelper.get(this.rutaApi, {
        palabra: textoBuscado
      })
        .then(response => {
          this.grillaItems = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEditarItem(item) {
      this.loading = true;
      HttpHelper.get(this.rutaApi, {
        id: item.Id_Talonario
      })
        .then(response => {
          this.itemActivo = Object.assign({}, response.data);
          this.ejecutarAccion("Editar");
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaBorrarItem(item) {
      this.itemActivo = item;
      this.ejecutarAccion("Borrar");
    },
    mostrarError(error) {
      let detalle =
        error.response === undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
